/**
 * Localization messages for RuleInfo component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Rule Name': 'ruleRecs.ruleInfo.ruleNameLabel',
  'Enter rule name': 'ruleRecs.ruleInfo.ruleNamePlaceholder',
  'Enter rule description': 'ruleRecs.ruleInfo.ruleDescriptionPlaceholder',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleInfoMessage = keyof typeof invertedMessages;

export default invertedMessages;
